import React from 'react';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {ReportTableProps} from 'src/components/ReportTable';

import {CreateReportPrompt} from './../CreateReportPrompt/CreateReportPrompt';
import {
  EmptyButton,
  EmptyContainer,
  EmptyHeader,
  EmptyHeaderText,
} from './CreateReportPromptHeader.styles';

type CreateReportPromptHeaderProps = Pick<
  ReportTableProps,
  'entityName' | 'projectName' | 'onCreateReportPrompt'
> & {
  createReport: (msg: string) => void;
};

export const CreateReportPromptHeader = ({
  createReport,
  entityName,
  onCreateReportPrompt,
  projectName,
}: CreateReportPromptHeaderProps) => (
  <EmptyContainer>
    <EmptyHeader>
      <EmptyHeaderText>Reports</EmptyHeaderText>
      <EmptyButton
        data-test={`create-report-button`}
        primary
        onClick={() => {
          createReport('empty reports tab');
        }}
        content="Create report"
      />
    </EmptyHeader>
    <CreateReportPrompt
      location={`reports tab`}
      entityName={entityName}
      projectName={projectName}
      onCreateReport={onCreateReportPrompt}
    />
  </EmptyContainer>
);
